<div class="w-full h-full">
  <router-outlet></router-outlet>
</div>
